module.exports = __webpack_public_path__ + "img/cfdi_file_icon.b6ba5da5.svg";